module.exports = __webpack_public_path__ + "static/media/teammateUserWhite.45221ee3.svg";